import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
  TextField,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { SECONDARY_COLOR, STATUS_ATIVO } from '../../utils';
import { PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR } from '../../utils/dadosTelas';
//import ActionsField from './ActionsField';
import DialogoStatus from './DialogoStatus';
import Filter from './Filter';
import StatusField from './StatusField';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: SECONDARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 'bold',
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

function ParagradoImposto({ label, valor }) {
  return (
    <p>
      <span
        style={{
          fontWeight: 'bold',
          marginRight: '5px',
        }}
      >
        {label}:
      </span>
      <span>{valor} </span>
    </p>
  );
}

const Panel = (props) => (
  <div>
    <ParagradoImposto label="Descrição" valor={props.record.descricao} />
  </div>
);
//
const MyList = ({ ...props }) => {
  const classes = useStyles();
  const refresh = useRefresh();
  const refDialogoStatus = useRef(null);

  function handleStatus({ id }) {
    if (refDialogoStatus.current) {
      refDialogoStatus.current.handleOpen(id);
    }
  }

  return (
    <>
      <Title title="Tabela CST IBS/CBS" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <StatusField
            source="status"
            label="Status"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextField
            source="id"
            label="Id"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextField
            source="cst"
            label="CST"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextField
            source="descricao"
            label="Descrição"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="lalala"
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //handleStatus={handleStatus}
            actions={[
              {
                title: 'Detalhes',
                icon: <VisibilityIcon />,
                onClick: (record) => {},
              },
              {
                title: (record) =>
                  record.status === STATUS_ATIVO
                    ? 'Marcar como inativo'
                    : 'Marcar como ativo',
                icon: ({ record }) =>
                  record.status === STATUS_ATIVO ? (
                    <CancelIcon />
                  ) : (
                    <CheckCircleOutlineIcon />
                  ),
                onClick: (record) => handleStatus(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoStatus
        ref={refDialogoStatus}
        handleClose={() => {
          refresh();
        }}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR}>
    <ContainerMyList
      {...props}
      expand={<Panel />}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Tabela CST IBS/CBS"
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
